import React from 'react';
import { API_URL } from '@/api/constant';

interface TableItemIdentityProps {
  image?: string;
  name: string;
  subtitle?: string;
  fallbackText?: string;
  imageClassName?: string;
  containerClassName?: string;
}

export const TableItemIdentity: React.FC<TableItemIdentityProps> = ({
  image,
  name,
  subtitle,
  fallbackText = 'No Img',
  imageClassName = '',
  containerClassName = '',
}) => {
  const imageUrl = image 
    ? (image.startsWith('http') ? image : `${API_URL}/${image}`)
    : null;

  return (
    <div className={`flex items-center gap-3 ${containerClassName}`}>
      <div className={`w-10 h-10 rounded-lg bg-secondary/20 overflow-hidden flex-shrink-0 border border-secondary/10 ${imageClassName}`}>
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={name}
            className="w-full h-full object-cover"
            onError={(e) => {
              (e.target as HTMLImageElement).src = 'https://placehold.co/100x100?text=No+Image';
            }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[10px] text-muted-foreground font-medium">
            {fallbackText}
          </div>
        )}
      </div>
      <div className="flex flex-col min-w-0">
        <span className="font-medium text-foreground line-clamp-1" title={name}>
          {name}
        </span>
        {subtitle && (
          <span className="text-[10px] text-muted-foreground uppercase tracking-wider truncate">
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
};
